var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Grid, IconButton, MenuItem, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { MENSAGENS, getMesesDoAno } from '../../../utils';
import InputDados from '../../../components/input_dados';
import { FinanceiroListarBase } from '../components/FinanceiroListarBase';
import { alterarSituacaoLancamentosFolha, getCombosListar, getLancamentosFolhas } from './lancamentos_folhas.service';
export var LancamentosFolhasListar = function () {
    var _a = useState([]), reeducandosDisponiveis = _a[0], setReeducandosDisponiveis = _a[1];
    var _b = useState(-1), buscaMes = _b[0], setBuscaMes = _b[1];
    var _c = useState(-1), buscaReeducandoSelecionado = _c[0], setBuscaReeducandoSelecionado = _c[1];
    var _d = useState('-1'), buscaStatusSelecionado = _d[0], setBuscaStatusSelecionado = _d[1];
    var _e = useState(0), recarregarTrigger = _e[0], setRecarregarTrigger = _e[1];
    var mesesAno = getMesesDoAno();
    useEffect(function () {
        var carregarCombos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getCombosListar()];
                    case 1:
                        resp = _a.sent();
                        if ((resp === null || resp === void 0 ? void 0 : resp.Status) !== 'ERRO') {
                            setReeducandosDisponiveis(resp.reeducandos || []);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        carregarCombos();
    }, []);
    var alterarSituacaoLancamento = function (id, situacao) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, alterarSituacaoLancamentosFolha(id.toString(), situacao)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        alert(situacao === 'ATIVO' ? MENSAGENS.REGISTRO_ATIVADO : MENSAGENS.REGISTRO_INATIVADO);
                        setRecarregarTrigger(function (prev) { return prev + 1; });
                    }
                    else if (resp) {
                        alert(resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var inativarParametrosOpcao = function (params) {
        var _a = params.row, id = _a.id, parametros_em_uso = _a.parametros_em_uso, situacao = _a.situacao;
        return situacao === 'Ativo' ? (_jsx(Tooltip, __assign({ title: 'Inativar lançamento', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 1, paddingRight: 0, marginTop: -1 }, onClick: function () {
                    if (parametros_em_uso) {
                        alert('Não é possível alterar ou excluir este lançamento: a folha vinculada já foi lançada/fechada.');
                        return;
                    }
                    if (confirm('Tem certeza que deseja INATIVAR o registro selecionado?')) {
                        alterarSituacaoLancamento(id, 'Inativo');
                    }
                } }, { children: _jsx(CancelIcon, { sx: { fontSize: 30 } }) })) }))) : (_jsx(Tooltip, __assign({ title: 'Ativar lançamento', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 1, paddingRight: 0, marginTop: -1 }, onClick: function () {
                    if (confirm('Tem certeza que deseja ATIVAR o registro selecionado?')) {
                        alterarSituacaoLancamento(id, 'Ativo');
                    }
                } }, { children: _jsx(CancelIcon, { sx: { fontSize: 30 } }) })) })));
    };
    var services = {
        getDados: function (textoBusca, _, paginationModel) {
            return getLancamentosFolhas(textoBusca, buscaMes === -1 ? null : buscaMes.toString(), buscaReeducandoSelecionado === -1 ? null : buscaReeducandoSelecionado.toString(), buscaStatusSelecionado === '-1' ? null : buscaStatusSelecionado, paginationModel);
        },
    };
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'id', headerName: 'Código', width: 100 },
        { field: 'nome', headerName: 'Nome', width: 300 },
        {
            field: 'mes_referencia',
            headerName: 'Mês Referência',
            width: 150,
            valueGetter: function (value) { var _a; return "".concat(((_a = mesesAno.find(function (item) { return item.value === value; })) === null || _a === void 0 ? void 0 : _a.label) || ''); },
        },
        { field: 'status', headerName: 'Status', width: 150 },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(FinanceiroListarBase, { pagina: PAGINAS.LANCAMENTOS_FOLHAS, paginaEspecificaPermissao: FUNCIONALIDADES.LANCAMENTOS_FOLHAS, rota: ROUTES.LANCAMENTOS_FOLHAS, colunas: COLUNAS_FUNCIONALIDADE, services: services, opcaoAdicional: inativarParametrosOpcao, filtrosJSX: _jsxs(Grid, __assign({ container: true, spacing: 1, mt: 2, mb: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'mes_busca', label: 'M\u00EAs', placeholder: 'M\u00EAs', value: buscaMes, onChange: function (event) { return setBuscaMes(event.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), mesesAno.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.value }, { children: item.label }), item.value)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'reeducando', label: 'Colaborador', placeholder: 'Colaborador', value: buscaReeducandoSelecionado, onChange: function (event) { return setBuscaReeducandoSelecionado(event.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), reeducandosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'status', label: 'Status', placeholder: 'Status', value: buscaStatusSelecionado, onChange: function (event) { return setBuscaStatusSelecionado(event.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), _jsx(MenuItem, __assign({ value: 'Aberto' }, { children: "Aberto" })), _jsx(MenuItem, __assign({ value: 'Fechado' }, { children: "Fechado" }))] })) }))] })) }, recarregarTrigger));
};
export default LancamentosFolhasListar;
